import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Shop } from "@hermes/api-model-shop";
import { RouterService } from "@hermes/utils-generic/services/router";

import { ShopInfoEvent, StorePageLinkMode } from "../../types/shop-info.type";

@Component({
    selector: "h-shop-info-header",
    templateUrl: "./shop-info-header.component.html",
    styleUrls: ["./shop-info-header.component.scss"],
    standalone: false,
})
export class ShopInfoHeaderComponent {
    @Input()
    public shop!: Shop;

    /**
     * Determines the type of link to display.
     */
    @Input()
    public linkMode: StorePageLinkMode = "none";

    /**
     * Sets the store title level
     */
    @Input()
    public headerLevelShopTitle: number = 3;

    @Output()
    public shopInfoHeaderEvents = new EventEmitter<ShopInfoEvent>();

    constructor(private routerService: RouterService) {}

    public navigateOnShopPage(event: MouseEvent | KeyboardEvent): void {
        this.shopInfoHeaderEvents.emit("shop_page");

        event.preventDefault();

        if (this.linkMode === "external") {
            this.routerService.nativeRedirect(this.shop.url, true);
            return;
        }
        this.routerService.spaRedirect(this.shop.url);
    }
}
